import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function DeleteTrip({
  isVisible,
  setIsVisible,
  client_id,
  trip_id,
  handleAction,
}) {
  const [open, setOpen] = useState(isVisible);
  const content = ` Please confirm delete Trip on this device.
    This action can not be undone!`;

  const handleCancel = (e) => {
    e.preventDefault();
    setOpen(false);
    setIsVisible(false);
  };

  const handleConfirm = (e) => {
    e.preventDefault();
    setIsVisible(false);
    setOpen(false);
    handleAction(e);
  };

  return (
    <div>
      {/* Dialog that is displayed if the state open is true */}
      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Delete Trip`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            variant="contained"
            data-client_id={client_id}
            data-trip_id={trip_id}
            color="secondary"
            onClick={handleConfirm}
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DeleteTrip;
